import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React, {useEffect, useMemo, useState} from "react";
import OWASP from "../../../../util/owasp";

import {el, es} from "date-fns/locale";
import {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Http} from "../../../../helpers/Http";

registerLocale("es-sunday", {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
    },
});
const MantApproval = ({ MySwal, title, idEdit, fnCrear, showCreate, zona, agencia, list, icon, user, showSpinnerLoader, setItemSelected }) => {
    const {handleSubmit, reset, register, setValue, formState: {errors}} = useForm({mode: "onChange"});
    const [clienteId, setClienteId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [showAccepted, setShowAccepted] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [searchTerm, setSearchTerm] = useState(CONFIGURACIONES.INIT.STRING);
    const [isBloqueado, setIsBloqueado] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [anexos, setAnexos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [tipoCreditoRefId, setTipoCreditoRefId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [accionRef, setAccionRef] = useState(CONFIGURACIONES.INIT.NULL);
    const [checkFichaEvaluacion, setCheckFichaEvaluacion] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [checkCronogramaPagos, setCheckCronogramaPagos] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    const onSubmit1 = (form) => {
        let elmFichaEvaluacion = document.getElementById(`fichaEvaluacion`);
        elmFichaEvaluacion.classList.remove('add-border-red');

        // let elmCronogramaPagos = document.getElementById(`cronogramaPagos`);
        // elmCronogramaPagos.classList.remove('add-border-red');

        if (!checkFichaEvaluacion) {
            elmFichaEvaluacion.classList.add('add-border-red');
        }

        // if (!checkCronogramaPagos) {
        //     elmCronogramaPagos.classList.add('add-border-red');
        // }

        if (!checkFichaEvaluacion) { return; }

        form['zonaId'] = zona;
        form['agenciaId'] = agencia;
        
        let formData = {
            'accion': form.accion,
            'motivo': form.motivo
        }
        fnCrear(formData);
    };

    const filteredData = list.filter((item) =>
        item.numeroDocumento.toLowerCase().includes(searchTerm.toLowerCase()) || item.cliente.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCheck = (id) => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_FALSE);
        setClienteId(id);
        setValue('solicitudId', id);
        fnSearchForId(id, zona, agencia);
    };


    const fnSearchForId = (id, zona, agencia) => {
        if (!agencia || !zona) { return; }
        showSpinnerLoader();
        let data = {
            body: {
                'agenciaId': agencia,
                'zonaId': zona,
                'usuarioRegistro': user.user,
            }
        }
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/aprobacion/${id}`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setItemSelected(rpta.data);
                setAnexos(rpta.data.anexos);
            }
        });
    };

    const fnVerFichaEvaluacion = () => {
        setCheckFichaEvaluacion(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnVerCronogramaPagos = () => {
        setCheckCronogramaPagos(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnDownloadFile = async (param) => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/descargar-archivo/${param.id}`).then(async (rpta) => { 
            if (rpta.ok) {
                const blob = await rpta.blob(); 
                
                const disposition = rpta.headers.get('Content-Disposition');
                let filename = 'downloaded_file'; // Nombre por defecto
                
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                // 4. Crear una URL temporal y un enlace invisible
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                
                a.href = url;
                a.download = filename; // Asigna el nombre de archivo
                
                // 5. Simular el click para iniciar la descarga
                document.body.appendChild(a);
                a.click();

                // 6. Limpiar el DOM y revocar la URL temporal
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        });
    };

    useEffect(() => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
        setAccionRef(CONFIGURACIONES.INIT.NULL);
        setCheckFichaEvaluacion(CONFIGURACIONES.INIT.STATUS_FALSE);
        setCheckCronogramaPagos(CONFIGURACIONES.INIT.STATUS_FALSE);
        
        setClienteId(CONFIGURACIONES.INIT.NUMBER);
        setValue('solicitudId', CONFIGURACIONES.INIT.STRING);
        reset();
    }, [zona, agencia, list]);

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>

                                <div className="row mt-3">
                                    <div className="col-xs-12 col-md-12">
                                        {/* Input alineado con la tabla */}
                                        <div className="row">

                                            <div className="col-md-1">
                                                <label htmlFor="buscar" className="control-label col-form-label-sm">Cliente</label>
                                            </div>
                                            <div className="col-md-5 pl-0">
                                                <input
                                                    type="text"
                                                    name="buscar"
                                                    id="buscar"
                                                    className="form-control form-control-sm w-50 me-2"
                                                    placeholder="Buscar..."
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>



                                        {/* Tabla */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="bg-success text-white">
                                                <tr>
                                                    <th className="text-center">Seleccionar</th>
                                                    <th>T. Documento</th>
                                                    <th>Num. Documento</th>
                                                    <th>Cliente</th>
                                                    <th>Monto</th>
                                                    <th>Actividad</th>
                                                    <th>Condición</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {filteredData.length > 0? (
                                                    filteredData.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">
                                                                <input type="radio" className="text-center" checked={el.id === clienteId } onChange={() => handleCheck(el.id)}/>
                                                            </td>
                                                            <td>{el.tipoDocumento}</td>
                                                            <td>{el.numeroDocumento}</td>
                                                            <td>{el.cliente}</td>
                                                            <td>{el.montoSolicitado}</td>
                                                            <td>{el.actividadNegocio}</td>
                                                            <td>{el.condicion}</td>
                                                        </tr>
                                                        </React.Fragment>))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={7}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <hr className="bg-success pt-1" />
                                {/* <div className="row mt-3">
                                    {!isBloqueado && <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Información del Titular</h6>
                                        </div>
                                    </div>}

                                    {!isBloqueado && <div className="col-xs-12 col-md-12">
                                        <div className="table-responsive">
                                            <table
                                                className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th>Tipo de Dirección</th>
                                                    <th>Departamento</th>
                                                    <th>Provincia</th>
                                                    <th>Distrito</th>
                                                    <th>Dirección</th>
                                                    <th>Teléfono</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {direcciones.length >0?(
                                                    direcciones.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr>
                                                                <td>{el.tipo}</td>
                                                                <td>{el.departamento}</td>
                                                                <td>{el.provincia}</td>
                                                                <td>{el.distrito}</td>
                                                                <td>{el.direccion}</td>
                                                                <td>{el.telefono}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={6}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>}
                                </div> */}

                                {!isBloqueado && <div className="row">
                                    <div className="col-md-4 col-xs-12">
                                        <div className="form-group row align-items-center mb-2">
                                            <label
                                                htmlFor="fichaEvaluacion"
                                                className="col-sm-7 col-form-label"
                                            >
                                                Ficha de Evaluación <span className="text-danger">*</span>
                                            </label>
                                            <div className="col-sm-5">
                                                <WaveButton id="fichaEvaluacion" type="button" className="btn btn-sm btn-outline-secondary ml-auto wave-effect" onClick={fnVerFichaEvaluacion}>
                                                    Ver Detalle
                                                </WaveButton>
                                            </div>
                                        </div>
                                    </div>
{/* 
                                    <div className="col-md-4 col-xs-12">
                                        <div className="form-group row align-items-center mb-2">
                                            <label
                                                htmlFor="cronogramaPagos"
                                                className="col-sm-7 col-form-label"
                                            >
                                                Cronograma de Pagos <span className="text-danger">*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <WaveButton id="cronogramaPagos" type="button" className="btn btn-sm btn-outline-secondary ml-auto wave-effect" onClick={fnVerCronogramaPagos}>
                                                    Ver Detalle
                                                </WaveButton>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>}

                                {!isBloqueado && <div className="row">
                                    <div className="col-md-10 col-xs-12 mt-2">
                                        <h6 className="text-muted">Documentación Anexada</h6>
                                        <div className="table-responsive">
                                            <table
                                                className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th>Tipo de Archivo</th>
                                                    {/* <th>Nombre de Archivo</th> */}
                                                    <th>Fecha de Subida</th>
                                                    <th>Adjuntado Por</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {anexos.length > 0? (
                                                    anexos.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{item.tipoAnexo}</td>
                                                        {/* <td>{item.nombreArchivo}</td> */}
                                                        <td>{item.fechaRegistro}</td>
                                                        <td>{item.usuarioRegistro}</td>
                                                        <td>
                                                            <WaveButton type="button" className="btn btn-sm btn-outline-info" onClick={() => fnDownloadFile(item)}>
                                                                <i className="mdi mdi-eye"></i>
                                                            </WaveButton>
                                                        </td>
                                                    </tr>
                                                    ))
                                                ):(
                                                    <tr>
                                                        <td colSpan="4" className="text-center text-muted">
                                                            <span className="text-danger">No se encontraron resultados</span>
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>}

                                {!isBloqueado && <div className="row">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="accion" className="control-label col-form-label">Acción <span className="text-danger">*</span></label>
                                            <select
                                                {...register("accion", {
                                                    required: OWASP.REQUIRED,
                                                    onChange: (e) => {
                                                        setAccionRef(e.target.value);
                                                    }
                                                })} className="form-control" id="accion"  defaultValue={""}
                                            >
                                                <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                {
                                                    CONFIGURACIONES.INIT.LIST.ACCIONES.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.accion && errors.accion.message }</small>
                                        </div>
                                    </div>

                                    {accionRef && accionRef !== CONFIGURACIONES.INIT.ACCION_APROBAR && <div className="col-xs-12 col-md-7">
                                        <div className="form-group">
                                            <label htmlFor="motivo" className="control-label col-form-label">Motivo <span className="text-danger">*</span></label>
                                            <textarea {...register("motivo", {
                                                        required: OWASP.REQUIRED,
                                                        pattern: {
                                                            value: OWASP.VALIDATIONS.GENERAL,
                                                            message: OWASP.MESSAGES.DEFAULT  
                                                        },
                                                        onChange: (e) => {
                                                            
                                                        }
                                                    })} className="form-control no-resize" rows={3}></textarea>
                                            <small className="invalid-feedback"> { errors.motivo && errors.motivo.message }</small>
                                        </div>
                                    </div>}
                                </div>}
                            </div>

                        </div>

                        <div className="action-form mt-3 d-flex justify-content-end">
                            <div className="form-group m-0 p-0 text-left">
                                {showCreate && clienteId > 0 && showAccepted && <WaveButton type="submit" className="btn btn-sm btn-outline-success waves-effect ml-2">
                                    <i className="mdi mdi-arrow-right-bold"></i> Guardar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
               </div>
            </>
            }
        </>
    )
}
export default MantApproval;